var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayoutReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1976d2",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228,208H212V88a4,4,0,0,0-4-4H172a4,4,0,0,0-4,4V208H140V136a4,4,0,0,0-4-4H100a4,4,0,0,0-4,4v72H68V168a4,4,0,0,0-4-4H28a4,4,0,0,0-4,4v40H20a4,4,0,0,0,0,8H228a4,4,0,0,0,0-8ZM60,208H32V172H60Zm76,0H108V140h28Zm76,0H184V92h28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutReport);
export default __webpack_public_path__ + "static/media/payout_report.83c8ed232f3a9ce53c046beb52191b9a.svg";
export { ForwardRef as ReactComponent };